// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--JLXJkeMZB8A7OadW"};